const pinsData = [
  {
    id: 1,
    status: "default",
    name: "sanmon_gate",
    ar: false,
    arName: null,
    x: 652,
    y: 1530,
    visited: false,
  },
  {
    id: 2,
    status: "default",
    name: "maitreya_bodhisattva",
    ar: true,
    arName: "hotei",
    x: 655,
    y: 1050,
    visited: false,
  },
  {
    id: 3,
    status: "default",
    name: "idaten",
    ar: false,
    arName: null,
    x: 715,
    y: 965,
    visited: false,
  },
  {
    id: 4,
    status: "default",
    name: "kaipan",
    ar: true,
    arName: "kaipan",
    x: 905,
    y: 770,
    visited: false,
  },
  {
    id: 5,
    status: "default",
    name: "daiyu_hoden",
    ar: false,
    arName: null,
    x: 600,
    y: 690,
    visited: false,
  },
  {
    id: 6,
    status: "default",
    name: "statue_of_venerable_rahula",
    ar: false,
    arName: null,
    x: 720,
    y: 635,
    visited: false,
  },
  {
    id: 7,
    status: "default",
    name: "dharma_hall",
    ar: true,
    arName: "dragon",
    x: 650,
    y: 430,
    visited: false,
  },
  {
    id: 8,
    status: "default",
    name: "east_abbots_quarters",
    ar: false,
    arName: null,
    x: 820,
    y: 390,
    visited: false,
  },
  {
    id: 9,
    status: "default",
    name: "zen_hall",
    ar: false,
    arName: null,
    x: 380,
    y: 775,
    visited: false,
  },
  {
    id: 10,
    status: "default",
    name: "founders_hall",
    ar: false,
    arName: null,
    x: 230,
    y: 1285,
    visited: false,
  },
];

export default pinsData;
